import { services } from "../../../../constants";
import { getCookieByName, setCookie } from "../../../../utils/cookiesUtils";

// export default async function getJwtToken(userData) {
//   try {
//     const {
//       profileId = "",
//       token = "",
//       accountStatus = "",
//       parentalControl = "",
//       updateCache = true,
//       isMasterProfile = false
//     } = userData;
//     let queryParams = [`profileId=${profileId}`, `spxToken=${token}`];
//     if (accountStatus) {
//       queryParams.push(`accountStatus=${accountStatus}`);
//     }
//     if (parentalControl) {
//       queryParams.push(`parentalControl=${parentalControl}`);
//     }
//     let response = {};
//     if (isMasterProfile) {
//       const masterJwt = getCookieByName("starz-jwt");
//       response = { data: { profileJwtToken: masterJwt } };
//     } else {
//       const queryString = queryParams.join("&");
//       const url = this.buildUrl("auth", `${services.jwtToken}?${queryString}`);
//       response = await this.http.get(url);
//     }

//     return response.data;
//   } catch (error) {
//     this.handleErrorResponse(error);
//   }
// }

export default async function getJwtToken(userData) {
  try {
    const { profileId = "", token = "", accountStatus = "", parentalControl = "", isMasterProfile = false } = userData;
    let queryParams = [];
    if (accountStatus) {
      queryParams.push(`accountStatus=${accountStatus}`);
    }
    if (parentalControl) {
      queryParams.push(`parentalControl=${parentalControl}`);
    }
    const queryString = queryParams ? queryParams.join("&") : null;

    let response = {};

    if (isMasterProfile) {
      const masterJwt = getCookieByName("starz-jwt");
      response = { data: { profileJwtToken: masterJwt } };
    } else {
      const url = this.buildUrl("auth", `${services.authentication}${queryString ? `?${queryString}` : ""}`);
      const requestHeaders = {
        headers: {
          Authorization: `${token}`
        }
      };
      requestHeaders.headers[`x-profile-id`] = profileId;
      response = await this.http.post(`${url}`, {}, requestHeaders);
    }
    return response.data;
  } catch (error) {
    this.handleErrorResponse(error);
  }
}
